import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=0bcb58fb&scoped=true"
import script from "./ProductsItem.vue?vue&type=script&lang=js"
export * from "./ProductsItem.vue?vue&type=script&lang=js"
import style0 from "./ProductsItem.vue?vue&type=style&index=0&id=0bcb58fb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb58fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bcb58fb')) {
      api.createRecord('0bcb58fb', component.options)
    } else {
      api.reload('0bcb58fb', component.options)
    }
    module.hot.accept("./ProductsItem.vue?vue&type=template&id=0bcb58fb&scoped=true", function () {
      api.rerender('0bcb58fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ProductsItem.vue"
export default component.exports